import React, { useEffect, useState } from "react";
import { Row, Col, Button } from 'react-bootstrap';
import { Carousel } from 'react-responsive-carousel';

import styles from "./PartialProductCard.module.css"

import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { IColor } from '../../utilities/settings'

export interface IPartialProductCard {
    itemId: number,
    itemCode: string,
    itemDescription: string,
    assetURL: string,
    modelCode: string,
    unitPrice: number,
    displayOrder: number,
    brand: any,
    itemName: string,
    newPrice: number,
    isOfferAvailable: boolean,
    isNewArrival: boolean,
    isInStock: boolean
}
interface PropsType {
    productCard: IPartialProductCard,
    colorCode: IColor
}


export default function PartialProductCard(props: PropsType) {
    const responsive = useSelector((state: RootState) => state.responsive);
    const [isWeb, setIsWeb] = useState<boolean>(true);
    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
    }, [])

    function price(val: number) {
        var value = (Math.round(val * 100) / 100).toFixed(2);
        return "Rs. " + String(value).replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1,');
    }

    return (
        <React.Fragment>
            {/* <div className={`${styles.mainContainer}`} style={{ filter: props.productCard.isInStock ? "null" : "grayscale(100%)" }}> */}
            <div className={`${styles.mainContainer}`} >
                <Col key={props.productCard.itemId} lg="12" md="12" xs="12" className={`${styles.fade} d-flex justify-content-center`}>
                    <div className={`${styles.brandSection} ${styles.fade}`}>
                        <Row className={`${styles.row}`} >
                            <Row className={`${styles.row}`}>
                                <div className={`${styles.mainImageContainer}`} style={{ backgroundColor: props.colorCode.primaryColor }}>
                                    {props.productCard.isOfferAvailable ?
                                        <div className={`jkoa-productListing-specialOffer`}>Offer</div>
                                        : null
                                    }
                                    {props.productCard.isNewArrival ?
                                        <div className={`jkoa-productListing-newArrival`} style={{ right: "0", lineHeight: isWeb ? "40px" : "20px" }}>New Arrival</div>
                                        : null
                                    }
                                    <div className={`${styles.circle}`} style={{ color: props.colorCode.secondaryColor }}></div>
                                    <img className={`${styles.mainImage}`} src={props.productCard.assetURL}
                                        onError={(e: any) => { e.target.onerror = null; e.target.src = "https://sajkoaonline.blob.core.windows.net/jkoa/itemimage/350/jkoa_default.png" }} />
                                    <div className={`${styles.mainImageBellowBox}`}></div>
                                </div>
                            </Row>

                            <Row className={`${styles.row}`}>
                                <div className={`${styles.detailContainer}`}>
                                    <div className={`${styles.selectedBrandHeading}`}>
                                        <span>{props.productCard.brand.brandName}</span>
                                    </div>
                                    <div className={`${styles.mainText}`}>
                                        <a style={{ color: "#2E5834", cursor: "pointer", textDecoration: "none" }}
                                            href={`/productDetails?ic=${props.productCard.itemCode}&${props.productCard.itemName.replace(/ /g, "_").toUpperCase()}`}>
                                            {/* onClick={() => window.open("/productDetails?ic=" + props.productCard.itemCode, '_blank')}> */}
                                            <p className={`${styles.lineClamp}`}>{props.productCard.itemName}</p>
                                        </a>
                                    </div>
                                    <div className={`${styles.priceContainer}`}>
                                        {props.productCard.isOfferAvailable == false ?
                                            <div className={`${styles.price}`} >
                                                <div>{props.productCard.unitPrice != 0 ? price(props.productCard.unitPrice) : ""}</div>
                                            </div>
                                            :
                                            <div style={{ overflow: "hidden", width: "100%" }}>
                                                <div className={`${styles.priceCut}`}>
                                                    <del>{price(props.productCard.unitPrice)}</del>
                                                </div>
                                                <div className={`${styles.price}`}>
                                                    <span>{price(props.productCard.newPrice)}</span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <Row className={`${styles.outOfStock}`}>
                                        {props.productCard.isInStock ?
                                            null :
                                            <div>
                                                OUT OF STOCK!
                                            </div>
                                        }
                                    </Row>
                                    <Row className={`${styles.row}`} style={{ paddingBottom: "3rem", paddingTop: "1rem" }}>
                                        <Col lg="12" md="12" xs="12" style={{ paddingBottom: "5px" }}>
                                            <a style={{ textDecoration: "none" }} href={`/productDetails?ic=${props.productCard.itemCode}&${props.productCard.itemName.replace(/ /g, "_").toUpperCase()}`}>
                                                <Button
                                                    // onClick={() => window.open("/productDetails?ic=" + props.productCard.itemCode, '_blank')}
                                                    className="jkoa-card-blue-btn">
                                                    <div style={{ padding: "0", margin: "0" }}>EXPLORE</div>
                                                </Button>
                                            </a>
                                        </Col>
                                        <Col lg="6" md="6" xs="12" style={{ paddingBottom: "5px" }} hidden>
                                            <a style={{ textDecoration: "none" }} href={`/productCompare?ic=${props.productCard.itemCode}&${props.productCard.itemName.replace(/ /g, "_").toUpperCase()}`}>
                                                <Button
                                                    className="jkoa-card-transparent-blue-btn">
                                                    <div style={{ padding: "0", margin: "0" }}>COMPARE</div>
                                                </Button>
                                            </a>
                                        </Col>
                                    </Row>
                                </div>
                            </Row>
                        </Row>
                    </div>
                </Col>
            </div>
        </React.Fragment>
    )
}